import MainStore from "@/store";
import MainRouter from "@/router";

import localStore from "./store";
import localRoutes from "./router";

MainStore.registerModule("economic_group", localStore);
MainRouter.addRoutes(localRoutes);
